module.exports = __webpack_public_path__ + "img/logo.601180df.svg";